import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    textTransform: 'capitalize',
    maxWidth: 450,
    width: '100%',
    fontWeight: 'bold',
    minHeight: 40,
    fontSize: 18,
    background: '#FF8C69',
    color: '#fff',
    '&:hover': {
      color: '#FF8C69',
      border: '1px solid #FF8C69',
      background: '#fff4f1',
    },
    '&.Mui-disabled:hover': {
      cursor: 'not-allowed',
      pointerEvents: 'auto'
    }
  }
}));
